export class PatientNoteItem {
    stockLocationId: number;
    note: string;
    deviceId: number;
    patientId: number;
    userName: string;
    caseNumber: string;
    institutionId: number;
}